export const headerGranularitySwitcherTexts = {
    title: "activation.header.granularity.switcher.title",
};
